import { render, staticRenderFns } from "./colelHours.vue?vue&type=template&id=58f72316&"
import script from "./colelHours.vue?vue&type=script&lang=js&"
export * from "./colelHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports